let usage = `
<Icon account_circle size="12px" padding="30px 2px" />
<Icon account_circle size="16px" padding="28px 2px" color="primary" />
<Icon account_circle padding="24px 2px" color="blue"/>
<Icon account_circle size="36px" padding="18px 2px" color="red" />
<Icon account_circle size="52px" padding="10px 2px" color="gray-400" />
<Icon account_circle size="72px" color="#55aaff" :tooltip="tooltip"/>
`.slice(1);

export default {
  usage
};
